import React from 'react';
import Gallery from 'react-photo-gallery';

import Row from '../components/row';
import Title from '../components/title';

import G0 from './images/gallery.0.jpg';
import Gal1 from './images/gal1.JPG';
import G01 from './images/gallery.01.jpg';
import G02 from './images/gallery.02.jpg';
import L2 from '../rooms/loft/images/Loft.2.jpg';
import C3 from './images/calle3.jpg';
import G1 from './images/gallery.1.jpg';
import G2 from './images/gallery.2.jpg';
import G3 from './images/gallery.3.jpg';
import G4 from './images/gallery.4.jpg';
import G18 from './images/gallery.18.jpg';
import G19 from './images/gallery.19.jpg';
import G20 from './images/gallery.20.jpg';
import B10 from '../home/breakfast/images/breakfast4.jpg';



const preparePhoto = (photos) => {
  return photos.map(photo => ({
    src: photo.url,
    width: photo.width || 500,
    height: photo.height || 300,
    aspectRatio: photo.aspectRatio,
    lightboxImage: {
      src: photo.url
    }
  }))
}

const GalleryComponent = () => {
  const photos = [
    { url: G1, aspectRatio: 1.5 },
    { url: G0, aspectRatio: 0.7 },
    { url: G2, aspectRatio: 1.3 },
    { url: G3, aspectRatio: 1.5 },
    { url: G01, aspectRatio: 1.3 },
    { url: G4, aspectRatio: 1.5 },
    { url: G18, aspectRatio: 1.4 },
    { url: G19, aspectRatio: 1.5 },
    { url: G20, aspectRatio: 1.4 },
    { url: G02, aspectRatio: 1.2 },
    { url: C3, aspectRatio: 1.5 },
    { url: L2, aspectRatio: 1.4 },
    { url: B10, aspectRatio: 1.2 },
    { url: Gal1, aspectRatio: 1.2 },
  ]
    return (
      <Row>
        <Title title="Nuestras Fotos" />
        <div>
          <Gallery photos={preparePhoto(photos)} />
        </div>
      </Row>
  )
  };

export default GalleryComponent;



// WEBPACK FOOTER //
// ./src/gallery/index.js